import { useMemo } from 'react';
import { theme } from 'antd';

/** Memoized ConfigProvider theme for link-styled buttons — avoids re-creating on every render */
export function useLinkButtonTheme() {
  const { token } = theme.useToken();
  return useMemo(
    () => ({
      components: {
        Button: {
          colorLink: token.colorPrimary,
          colorLinkHover: token.colorLink,
          colorLinkActive: token.colorLinkActive,
        },
      },
    }),
    [token.colorPrimary, token.colorLink, token.colorLinkActive],
  );
}
